import React from 'react';
import logo from '../img/ic_launcher.png';
import Image from './Image';

const Body = () => {
    return (
        <div className="body-container">
            <Image></Image>
            <div className="description">
                <img className="icon-image" src={logo}></img>
                <div className="definition">
                    <dt>
                        타이머야
                    </dt>
                    <dd>
                        심플한 멀티 타이머
                    </dd>
                </div>
            </div>
        </div>
    );
}

export default Body;